
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 bg-[#1a1a1a] rounded-full"></div>
              <span className="text-sm font-medium text-gray-600 uppercase tracking-wider">About Us</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
              15년간의 업력을 바탕으로<br />
              <span className="text-[#007AFF]">세심한 수리</span>
            </h2>

            <div className="space-y-6 text-gray-700 text-base leading-relaxed">
              <p>
                청주 아이폰수리 마켓은 2010년부터 iPhone 3GS 단말기를 시작으로 iPad 1세대부터 최신 기종까지 수리 업무를 지속하고 있습니다.
              </p>
              <p>
                15년간의 업력을 바탕으로 세심한 수리, 높은 부품 퀄리티와 신뢰를 바탕으로 iPhone, iPad 사용 유저들에게 최상의 서비스를 제공하려고 노력하고 있습니다.
              </p>
              <p>
                정품 부품 사용과 철저한 품질 관리로 고객님의 소중한 기기를 새것처럼 복원해드립니다.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-8">
              <div>
                <div className="text-4xl font-bold text-[#007AFF] mb-2">15+</div>
                <div className="text-sm text-gray-600">년 경력</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#007AFF] mb-2">10K+</div>
                <div className="text-sm text-gray-600">수리 건수</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-[#007AFF] mb-2">98%</div>
                <div className="text-sm text-gray-600">만족도</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/c99dc7a7549e231b04ee549d68882537/7260e2cddd686c2185be1631382ac895.jpeg"
                alt="청주 아이폰수리 마켓 매장"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#007AFF] text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <div className="flex items-center gap-3 mb-3">
                <i className="ri-map-pin-line text-3xl"></i>
                <div>
                  <div className="font-bold text-lg">찾아오시는 길</div>
                  <div className="text-sm opacity-90">성안길 다이소 입구 앞</div>
                </div>
              </div>
              <div className="text-sm opacity-90">
                청주시 상당구 성언로 19-5
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
